import React from 'react';

/**
 * Kártya fejléccel. Két változat:
 *   - alap: a fejléc és a törzs egy dobozban, közös belső margóval
 *   - `flush`: a fejléc alatt elválasztó vonal, a törzs végigér (listákhoz)
 */
export default function PanelCard({
  title,
  subtitle,
  actions,
  icon,
  flush = false,
  className = '',
  bodyClassName = '',
  children,
}) {
  return (
    <div className={`card ${flush ? 'overflow-hidden' : 'p-6'} ${className}`}>
      {(title || actions) && (
        /* A fejléc TÖRHET: ha a cím és a gombok nem férnek egy sorba, a gombok a
           cím alá kerülnek. Enélkül keskeny kijelzőn a gombok a képernyőn KÍVÜLRE
           tolódtak (nem görgethetően), mert a gombsáv nem zsugorodhatott.
           A címblokk 15rem-es alapja miatt asztali nézetben minden marad egy sorban. */
        <div className={`flex flex-wrap items-start justify-between gap-x-4 gap-y-3 ${
          flush ? 'px-5 py-4 border-b border-white/[0.06]' : 'mb-5'
        }`}>
          <div className="flex items-start gap-3 min-w-0 flex-1 basis-60">
            {icon && (
              <span className="flex-shrink-0 w-9 h-9 rounded-lg bg-brand-500/12 border border-brand-400/20
                               text-brand-200 flex items-center justify-center">
                {icon}
              </span>
            )}
            <div className="min-w-0">
              {title && <h2 className="section-title">{title}</h2>}
              {subtitle && <p className="text-sm text-gray-500 mt-1 leading-relaxed">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="min-w-0 max-w-full">{actions}</div>}
        </div>
      )}
      <div className={bodyClassName}>{children}</div>
    </div>
  );
}

/** Üres állapot: ikon + rövid mondat, listák helyére. */
export function EmptyState({ icon, title, hint, className = '' }) {
  return (
    <div className={`px-6 py-12 text-center ${className}`}>
      {icon && (
        <span className="inline-flex w-12 h-12 rounded-xl bg-white/[0.03] border border-white/[0.06]
                         text-gray-700 items-center justify-center mb-4">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"
               strokeLinecap="round" strokeLinejoin="round" className="w-6 h-6">
            {icon}
          </svg>
        </span>
      )}
      <p className="text-sm text-gray-400">{title}</p>
      {hint && <p className="text-xs text-gray-600 mt-1.5">{hint}</p>}
    </div>
  );
}
